var render = function render(){var _vm=this,_c=_vm._self._c;return _c('my-currency',_vm._g(_vm._b({attrs:{"required":_vm.required},on:{"focus":_vm.onFocus},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},'my-currency',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }